import { render, staticRenderFns } from "./card-step-instructions.vue?vue&type=template&id=148d37ee&scoped=true&"
import script from "./card-step-instructions.vue?vue&type=script&lang=js&"
export * from "./card-step-instructions.vue?vue&type=script&lang=js&"
import style0 from "./card-step-instructions.vue?vue&type=style&index=0&id=148d37ee&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "148d37ee",
  null
  
)

export default component.exports